import axiosInstance from "../../../shared/api/axiosInstance";
import { EDIT_WISH_LIST } from "../../../shared/api/endpoints";
import { configReq } from "../../../shared/lib/functions";
export function editWishList({ id, userId, advertisementId }, token) {
  return axiosInstance.put(EDIT_WISH_LIST, { id, userId, advertisementId }, configReq(token));
}
